import { Box, Typography, Button, Stack, useTheme } from "@mui/material";
// TODO: Descomentar cuando se agregue la lógica para los botones
// import { IconButton } from "@mui/material";
import HotelIcon from "@mui/icons-material/Hotel";
import BathtubIcon from "@mui/icons-material/Bathtub";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
// TODO: Descomentar cuando se agregue la lógica para los botones
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
// import ShareIcon from "@mui/icons-material/Share";

interface PropertyHeaderProps {
    data: {
        price: string;
        status: string;
        address: string;
        beds: number;
        baths: number;
        sqft: string;
    };
}

export default function PropertyHeader({ data }: PropertyHeaderProps) {
    const theme = useTheme();
    return (
        <Box p={3} sx={{ mb: 4, width: "100%" }}>
            {/* Desktop Layout - Grid */}
            <Box
                sx={{
                    display: { xs: "none", md: "grid" },
                    gridTemplateColumns: "1fr auto auto",
                    gap: 8,
                    alignItems: "center",
                    width: "100%",
                }}
            >
                {/* Left section: Price, Status, Address */}
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <Stack 
                        direction="row" 
                        spacing={2} 
                        alignItems="center" 
                        sx={{ 
                            mb: 1, 
                            flexWrap: "wrap",
                        }}
                    >
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            sx={{
                                color: theme.palette.primary.main,
                                fontSize: "2rem",
                            }}
                        >
                            {data.price}
                        </Typography>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                px: 2,
                                py: 0.5,
                                borderRadius: 2,
                            }}
                        >
                            {data.status}
                        </Button>
                    </Stack>
                    <Typography
                        variant="body1"
                        sx={{
                            color: "#666",
                            fontSize: "0.875rem",
                            textAlign: "left",
                        }}
                    >
                        {data.address}
                    </Typography>
                </Box>

                {/* Center section: Property Metrics */}
                <Box>
                    <Stack
                        direction="row"
                        spacing={4}
                        justifyContent="center"
                        alignItems="flex-start"
                    >
                        {/* Beds */}
                        <Box sx={{ textAlign: "center" }}>
                            <HotelIcon
                                sx={{
                                    fontSize: 28,
                                    color: theme.palette.primary.main,
                                    mb: 1,
                                }}
                            />
                            <Typography
                                variant="body1"
                                fontWeight="bold"
                                sx={{
                                    color: theme.palette.primary.main,
                                    fontSize: "0.875rem",
                                }}
                            >
                                {data.beds} Beds
                            </Typography>
                        </Box>

                        {/* Baths */}
                        <Box sx={{ textAlign: "center" }}>
                            <BathtubIcon
                                sx={{
                                    fontSize: 28,
                                    color: theme.palette.primary.main,
                                    mb: 1,
                                }}
                            />
                            <Typography
                                variant="body1"
                                fontWeight="bold"
                                sx={{
                                    color: theme.palette.primary.main,
                                    fontSize: "0.875rem",
                                }}
                            >
                                {data.baths} Baths
                            </Typography>
                        </Box>

                        {/* Square Feet */}
                        <Box sx={{ textAlign: "center" }}>
                            <SquareFootIcon
                                sx={{
                                    fontSize: 28,
                                    color: theme.palette.primary.main,
                                    mb: 1,
                                }}
                            />
                            <Typography
                                variant="body1"
                                fontWeight="bold"
                                sx={{
                                    color: theme.palette.primary.main,
                                    fontSize: "0.875rem",
                                }}
                            >
                                {data.sqft}
                            </Typography>
                        </Box>
                    </Stack>
                </Box>

                {/* Right section: Action Buttons - Desktop only */}
                {/* TODO: Agregar lógica para botones de favorito y compartir */}
                {/* <Box>
                    <Stack direction="row" spacing={2}>
                        <IconButton
                            sx={{
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                width: 48,
                                height: 48,
                                "&:hover": {
                                    backgroundColor: theme.palette.primary.dark,
                                },
                            }}
                        >
                            <FavoriteBorderIcon />
                        </IconButton>
                        <IconButton
                            sx={{
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                width: 48,
                                height: 48,
                                "&:hover": {
                                    backgroundColor: theme.palette.primary.dark,
                                },
                            }}
                        >
                            <ShareIcon />
                        </IconButton>
                    </Stack>
                </Box> */}
            </Box>

            {/* Mobile Layout */}
            <Box
                sx={{
                    display: { xs: "flex", md: "none" },
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                {/* Price, Status, Address */}
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <Stack 
                        direction="row" 
                        spacing={2} 
                        alignItems="center" 
                        sx={{ 
                            mb: 1, 
                            flexWrap: "wrap",
                            justifyContent: "center",
                        }}
                    >
                        <Typography
                            variant="h3"
                            fontWeight="bold"
                            sx={{
                                color: theme.palette.primary.main,
                                fontSize: "1.75rem",
                            }}
                        >
                            {data.price}
                        </Typography>
                        <Button
                            variant="contained"
                            color="secondary"
                            sx={{
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                px: 2,
                                py: 0.5,
                                borderRadius: 2,
                            }}
                        >
                            {data.status}
                        </Button>
                    </Stack>
                    <Typography
                        variant="body1"
                        sx={{
                            color: "#666",
                            fontSize: "0.875rem",
                            textAlign: "center",
                        }}
                    >
                        {data.address}
                    </Typography>
                </Box>
            </Box>

            {/* Metrics for mobile/tablet - Left, Center, Right */}
            <Box
                sx={{
                    display: { xs: "flex", md: "none" },
                    justifyContent: "space-between",
                    mt: 2,
                    width: "100%",
                }}
            >
                {/* Beds - Left */}
                <Box sx={{ textAlign: "left" }}>
                    <HotelIcon
                        sx={{
                            fontSize: 28,
                            color: theme.palette.primary.main,
                            mb: 1,
                        }}
                    />
                    <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: "0.875rem",
                        }}
                    >
                        {data.beds} Beds
                    </Typography>
                </Box>

                {/* Baths - Center */}
                <Box sx={{ textAlign: "center", flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <BathtubIcon
                        sx={{
                            fontSize: 28,
                            color: theme.palette.primary.main,
                            mb: 1,
                        }}
                    />
                    <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: "0.875rem",
                        }}
                    >
                        {data.baths} Baths
                    </Typography>
                </Box>

                {/* Square Feet - Right */}
                <Box sx={{ textAlign: "right" }}>
                    <SquareFootIcon
                        sx={{
                            fontSize: 28,
                            color: theme.palette.primary.main,
                            mb: 1,
                        }}
                    />
                    <Typography
                        variant="body1"
                        fontWeight="bold"
                        sx={{
                            color: theme.palette.primary.main,
                            fontSize: "0.875rem",
                        }}
                    >
                        {data.sqft}
                    </Typography>
                </Box>
            </Box>

            {/* Action Buttons for mobile - Centered */}
            {/* TODO: Agregar lógica para botones de favorito y compartir */}
            {/* <Box
                sx={{
                    display: { xs: "flex", md: "none" },
                    justifyContent: "center",
                    mt: 2,
                }}
            >
                <Stack direction="row" spacing={2}>
                    <IconButton
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            width: 48,
                            height: 48,
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        }}
                    >
                        <FavoriteBorderIcon />
                    </IconButton>
                    <IconButton
                        sx={{
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            width: 48,
                            height: 48,
                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                            },
                        }}
                    >
                        <ShareIcon />
                    </IconButton>
                </Stack>
            </Box> */}
        </Box>
    );
}
